import React, { useState } from "react";
import Dropdown from "./GMBProfileDetails/Dropdown";
import { Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { fetchStoreCodes, resetStoreDetail } from "../../Store/Gmb/gmbStoreSlice";

const Filter = ({ handleFilterApplied }) => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    verified: null, // Initially no filter applied
    rating: null,
  });

  const handleFilterChange = (type, value) => {
    // Update the filters state
    const updatedFilters = { ...filters, [type]: value };
    setFilters(updatedFilters);

    // Check if both filters are "No Filter"
    const isNoFilter = updatedFilters.verified === null && updatedFilters.rating === null;

    // Notify parent component about the filter application
    handleFilterApplied(!isNoFilter);

    // Dispatch API call with updated filters
    dispatch(fetchStoreCodes(updatedFilters));
  };

  return (
    <div className="flex flex-row gap-2 justify-center items-center">
      {/* Verified Filter */}
      <div className="-mt-5 w-max">
        <Typography fontSize="12px">Verification</Typography>
        <Dropdown
          value={filters.verified === true ? "Verified Stores" : filters.verified === false ? "Not Verified Stores" : "verification"}
          optionList={["Verified Stores", "Not Verified Stores"]}
          className="p-3 text-lg w-40"
          onSelectedValue={(v) => {
            const verifiedValue =
              v === "Verified Stores" ? true : v === "Not Verified Stores" ? false : null;
            dispatch(resetStoreDetail());
            handleFilterChange("verified", verifiedValue);
          }}
          defaultValue={"verification"}
          showCheckbox={true}
        />
      </div>

      {/* Rating Filter */}
      <div className="-mt-5 w-max">
        <Typography fontSize="12px">Rating</Typography>
        <Dropdown
          value={filters.rating ? filters.rating.toString() : "rating"}
          optionList={["1", "2", "3", "4", "5"]}
          className="p-3 text-lg w-40 h-fit"
          onSelectedValue={(v) => {
            const ratingValue = ["1", "2", "3", "4", "5"].includes(v) ? Number(v) : null;
            dispatch(resetStoreDetail());
            handleFilterChange("rating", ratingValue);
          }}
          defaultValue={"rating"}
          showCheckbox={true}
        />
      </div>
    </div>
  );
};

export default Filter;
